export function maskString(input: string) {
  // Get the last 4 characters of the input string
  const lastFour = input.slice(-4);

  // Replace all characters except the last 4 with asterisks
  const masked = '*'.repeat(input.length - 4) + lastFour;

  return masked;
}
